import { getAuthenticated } from '../../services/RestTemplate';
import { isSimulationEnabled } from '../../shared/feature-flags';

const jurisdictionApi = '/general/brandsandjurisdictions';

/*
  Sandbox (SIMULATION) jurisdictions and their brands are left out unless asked for, and only asked for when the simulation is
  switched on: with it off, the request is the one that was always made. Asking is safe for everyone: a user who may not see any
  sandbox gets the same list as one who did not ask.
*/
export function getJurisdictions() {
    return getAuthenticated(
        jurisdictionApi,
        isSimulationEnabled() ? { includeSimulation: true } : undefined
    );
}
